import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  House,
  IdCard,
  Ambulance,
  UserRound,
  BookX,
  Download,
  LogOut,
  X,
  ChevronRight,
  History,
} from "lucide-react";
import { Button } from "../../ui/button";
import { showSuccessToast } from "../../../utils/toast-utils";

const Sidebar = ({ setOpen }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const isActive = (path) => location.pathname === path;

  const handleLogout = () => {
    showSuccessToast("Logged out successfully");
    navigate("/patient-login", { replace: true });
  };

  // Structured like Admin Sidebar
  const menuGroups = [
    {
      group: "Overview",
      items: [
        {
          name: "Dashboard",
          path: "/patient-dashboard",
          icon: <House size={20} />,
        },
      ],
    },
    {
      group: "Health Services",
      items: [
        {
          name: "Health Card",
          path: "/my-health-card",
          icon: <IdCard size={20} />,
        },
        {
          name: "Find Health Service",
          path: "/find-health-service",
          icon: <Ambulance size={20} />,
        },
        {
          name: "Booking History",
          path: "/booking-history",
          icon: <BookX size={20} />,
        },
        {
          name: "Download Report",
          path: "/download-report",
          icon: <Download size={20} />,
        },

      ],
    },
    {
      group: "Account",
      items: [
        {
          name: "Profile",
          path: "/profile",
          icon: <UserRound size={20} />,
        },
      ],
    },
  ];

  return (
    <div className="h-full flex flex-col text-slate-300 bg-gradient-to-b from-[#0A3E63] to-[#06213b] to overflow-hidden">
      {/* Header */}
      <div className="hidden md:flex items-center justify-between px-6 py-4 border-b border-white/10">
        <span className="font-semibold text-white text-lg tracking-wide">
          Menu
        </span>

        <button
          onClick={() => setOpen(false)}
          className="group relative flex items-center justify-center w-9 h-9 
               rounded-xl bg-white/5 backdrop-blur-md 
               border border-white/10 
               transition-all duration-200
               hover:bg-white/10 hover:scale-105 active:scale-95"
        >
          <X
            size={18}
            className="text-white/70 group-hover:text-white transition-colors"
            strokeWidth={2.2}
          />
        </button>
      </div>

      {/* Navigation Scroll Area */}
      <div className="flex-1 overflow-y-auto py-6 custom-scrollbar">
        {menuGroups.map((group, idx) => (
          <div key={idx} className="mb-6">
            <h3 className="px-8 text-[11px] font-bold uppercase tracking-widest text-slate-500 mb-3">
              {group.group}
            </h3>

            <ul className="space-y-1 px-4">
              {group.items.map((item) => (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    className={`
                      flex items-center justify-between px-4 py-3 rounded-lg transition-all duration-200 group
                      ${
                        isActive(item.path)
                          ? "bg-[#1E90FF] text-white shadow-lg shadow-blue-900/20"
                          : "hover:bg-white/5 hover:text-white"
                      }
                    `}
                  >
                    <div className="flex items-center gap-3">
                      <span
                        className={`${
                          isActive(item.path)
                            ? "text-white"
                            : "text-slate-400 group-hover:text-blue-400"
                        }`}
                      >
                        {item.icon}
                      </span>
                      <span className="text-sm font-medium">{item.name}</span>
                    </div>

                    {isActive(item.path) && (
                      <ChevronRight size={14} className="text-white/70" />
                    )}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      {/* Footer */}
      <div className="p-4 border-t border-white/10 bg-[#081a3a]/50">
        <div className="md:hidden">
          <Button
            onClick={handleLogout}
            className="w-full justify-start gap-3 bg-red-500/10 text-red-400 hover:bg-red-500 hover:text-white"
          >
            <LogOut size={18} /> Logout
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
